import { defineLevel } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   MONDE 2 · NIVEAU 3 — LA NAVETTE.

     0:00  bloc D3       14 s   rappel — pour ne pas ouvrir sur du vide
     0:14  boss           —     la Navette

   DERNIER niveau du monde 2 : il porte le boss. Un rappel court (D3) tient le
   joueur en action, puis le bloc de boss s'ouvre. La Navette ne vient pas au
   joueur — il faut aller la chercher au bon endroit, synthèse du monde du
   déplacement.

   ⚠️ D3 (14 s) démarre à 0 et se termine exactement quand le bloc de boss
   s'ouvre à 0:14, préservant le silence d'avant-boss.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineLevel({
  id: 'monde-2-3',
  // 14 s de rappel + 108 s de marge pour le combat de boss.
  duration: 122,
  blocks: [
    { at: 0, wave: 'd3-rappel' },
    { at: 14, wave: 'boss-navette' },
  ],
});
